export default __webpack_public_path__ + "static/media/set-square.8b10797d.png";